export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-fuchsia-950 to-gray-900 text-white overflow-hidden">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 sm:gap-12">
          {/* Brand Column */}
          <div className="md:col-span-2">
            <div className="mb-6">
              <img
                src="https://public.readdy.ai/ai/img_res/1e91301a-5055-4420-88b8-44ebb4ebd982.png"
                alt="Conejox Logo"
                className="h-10 sm:h-12 w-auto mb-4"
                loading="lazy"
                width="150"
                height="48"
              />
              <h3 className="text-xl sm:text-2xl font-bold mb-3">Conejox.com.es</h3>
            </div>
            <p className="text-sm sm:text-base text-white/70 leading-relaxed mb-6">
              Tu guía especializada en productos de bienestar íntimo premium. 
              Comparamos y recomendamos las mejores marcas del mercado para que 
              encuentres exactamente lo que buscas.
            </p>
            <div className="flex gap-3 sm:gap-4">
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-fuchsia-500 rounded-full flex items-center justify-center transition-colors cursor-pointer" aria-label="Instagram">
                <i className="ri-instagram-line text-lg sm:text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-fuchsia-500 rounded-full flex items-center justify-center transition-colors cursor-pointer" aria-label="Facebook">
                <i className="ri-facebook-fill text-lg sm:text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-fuchsia-500 rounded-full flex items-center justify-center transition-colors cursor-pointer" aria-label="Twitter">
                <i className="ri-twitter-x-line text-lg sm:text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-fuchsia-500 rounded-full flex items-center justify-center transition-colors cursor-pointer" aria-label="Pinterest">
                <i className="ri-pinterest-fill text-lg sm:text-xl"></i>
              </a>
            </div>
          </div>

          {/* Links Column */}
          <div>
            <h4 className="text-base sm:text-lg font-bold mb-4">Enlaces útiles</h4>
            <ul className="space-y-3">
              <li>
                <a href="#productos" className="text-sm sm:text-base text-white/70 hover:text-fuchsia-400 transition-colors cursor-pointer">
                  Productos LELO
                </a>
              </li>
              <li>
                <a href="#faq" className="text-sm sm:text-base text-white/70 hover:text-fuchsia-400 transition-colors cursor-pointer">
                  Preguntas frecuentes
                </a>
              </li>
              <li>
                <a href="#" className="text-sm sm:text-base text-white/70 hover:text-fuchsia-400 transition-colors cursor-pointer">
                  Guías de compra
                </a>
              </li>
              <li>
                <a href="#" className="text-sm sm:text-base text-white/70 hover:text-fuchsia-400 transition-colors cursor-pointer">
                  Blog
                </a>
              </li>
            </ul>
          </div>

          {/* Legal Column */}
          <div>
            <h4 className="text-base sm:text-lg font-bold mb-4">Legal</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-sm sm:text-base text-white/70 hover:text-fuchsia-400 transition-colors cursor-pointer">
                  Aviso Legal
                </a>
              </li>
              <li>
                <a href="#" className="text-sm sm:text-base text-white/70 hover:text-fuchsia-400 transition-colors cursor-pointer">
                  Política de Privacidad
                </a>
              </li>
              <li>
                <a href="#" className="text-sm sm:text-base text-white/70 hover:text-fuchsia-400 transition-colors cursor-pointer">
                  Política de Cookies
                </a>
              </li>
              <li>
                <a href="#contacto" className="text-sm sm:text-base text-white/70 hover:text-fuchsia-400 transition-colors cursor-pointer">
                  Contacto
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Disclaimers */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-8">
          <div className="space-y-4 text-xs sm:text-sm text-white/60">
            <p className="flex items-start gap-2">
              <i className="ri-information-line text-base sm:text-lg flex-shrink-0 mt-0.5"></i>
              <span>
                <strong className="text-white/80">Aviso de afiliados:</strong> Esta página contiene enlaces de afiliado de Amazon. 
                Si compras a través de ellos, podemos recibir una comisión sin coste adicional para ti. 
                Esto nos ayuda a mantener el sitio y seguir ofreciendo contenido de calidad.
              </span>
            </p>
            <p className="flex items-start gap-2">
              <i className="ri-error-warning-line text-base sm:text-lg flex-shrink-0 mt-0.5 text-yellow-400"></i>
              <span>
                <strong className="text-white/80">Contenido +18:</strong> Este sitio contiene información sobre productos 
                para adultos. Debes ser mayor de 18 años para acceder a este contenido.
              </span>
            </p>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10 bg-black/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 sm:py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-3 sm:gap-4 text-xs sm:text-sm text-white/60">
            <p className="text-center md:text-left">© 2025 Conejox.com.es – Todos los derechos reservados.</p>
            <a 
              href="https://conejox.com.es/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white/60 hover:text-fuchsia-400 transition-colors cursor-pointer"
            >
              Powered by Conejox
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
